import cn from 'classnames'
import React, { ComponentProps } from 'react'
import { useTranslate } from 'src/localization/Trns'

type ReceiptIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function ReceiptIcon(props: ReceiptIconProps) {
  const translate = useTranslate()
  const { className = '', ['aria-label']: ariaLabel, ...rest } = props
  const strokeColor = props.fill || '#1B2C4F'
  return (
    <svg
      className={cn('ReceiptIcon', className)}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={ariaLabel ?? translate('Receipt')}
      {...rest}
    >
      <path
        d="M3.875 3.00001C3.875 2.73479 3.98036 2.48044 4.16789 2.2929C4.35543 2.10536 4.60978 2.00001 4.875 2.00001C5.12262 1.99865 5.36548 2.06803 5.575 2.20001L6.508 2.80001C6.71704 2.93358 6.95993 3.00456 7.208 3.00456C7.45607 3.00456 7.69896 2.93358 7.908 2.80001L8.842 2.20001C9.05104 2.06643 9.29393 1.99545 9.542 1.99545C9.79007 1.99545 10.033 2.06643 10.242 2.20001L11.175 2.80001C11.384 2.93358 11.6269 3.00456 11.875 3.00456C12.1231 3.00456 12.366 2.93358 12.575 2.80001L13.508 2.20001C13.717 2.06643 13.9599 1.99545 14.208 1.99545C14.4561 1.99545 14.699 2.06643 14.908 2.20001L15.842 2.80001C16.051 2.93358 16.2939 3.00456 16.542 3.00456C16.7901 3.00456 17.033 2.93358 17.242 2.80001L18.175 2.20001C18.3845 2.06803 18.6274 1.99865 18.875 2.00001C19.1402 2.00001 19.3946 2.10536 19.5821 2.2929C19.7696 2.48044 19.875 2.73479 19.875 3.00001V21C19.875 21.2652 19.7696 21.5196 19.5821 21.7071C19.3946 21.8947 19.1402 22 18.875 22C18.6274 22.0014 18.3845 21.932 18.175 21.8L17.242 21.2C17.033 21.0664 16.7901 20.9955 16.542 20.9955C16.2939 20.9955 16.051 21.0664 15.842 21.2L14.908 21.8C14.699 21.9336 14.4561 22.0046 14.208 22.0046C13.9599 22.0046 13.717 21.9336 13.508 21.8L12.575 21.2C12.366 21.0664 12.1231 20.9955 11.875 20.9955C11.6269 20.9955 11.384 21.0664 11.175 21.2L10.242 21.8C10.033 21.9336 9.79007 22.0046 9.542 22.0046C9.29393 22.0046 9.05104 21.9336 8.842 21.8L7.908 21.2C7.69896 21.0664 7.45607 20.9955 7.208 20.9955C6.95993 20.9955 6.71704 21.0664 6.508 21.2L5.575 21.8C5.36548 21.932 5.12262 22.0014 4.875 22C4.60978 22 4.35543 21.8947 4.16789 21.7071C3.98036 21.5196 3.875 21.2652 3.875 21V3.00001Z"
        stroke={strokeColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.875 8H7.875"
        stroke={strokeColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.875 12H7.875"
        stroke={strokeColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.875 16H7.875"
        stroke={strokeColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
